/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  resultContent: 'resultContent_0fcf94c9',
  resultItem: 'resultItem_0fcf94c9',
  peoplePickerPersona: 'peoplePickerPersona_0fcf94c9',
  peoplePicker: 'peoplePicker_0fcf94c9',
  peoplePickerPersonaContent: 'peoplePickerPersonaContent_0fcf94c9',
};

export = styles;

loadStyles([{"rawString":".resultContent_0fcf94c9{display:table-row}.resultContent_0fcf94c9 .resultItem_0fcf94c9{display:table-cell;vertical-align:bottom}.peoplePickerPersona_0fcf94c9{width:180px}.peoplePickerPersona_0fcf94c9 .ms-Persona-details{width:100%}.peoplePicker_0fcf94c9 .ms-BasePicker-text{min-height:40px}.peoplePickerPersonaContent_0fcf94c9{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}"}]);
/* tslint:enable */